/**
 * Named gesture-tuning presets.
 *
 * Centralising the numbers here (instead of inline magic numbers per call
 * site) keeps the feel consistent across gestures and makes tuning a one-line
 * change. Each preset bundles the recognizer's `fling`/`thresholdPx` with the
 * consumer-facing layout constants (commit thresholds, rubber-band limits)
 * that the recognizer itself does not own.
 /** Waits for the app to finish booting (skeleton overlay disappears). */

import type { FlingConfig } from "./types";

const GESTURE_DEADZONE_PX = 8;

/**
 * Mobile navigation drawer: drag it toward its own edge to dismiss it.
 *
 * The drawer is anchored to the left, so only a leftward drag means anything.
 * Dragging the other way has nothing to reveal — it gets a short, capped
 * rubber-band so the panel acknowledges the finger without ever detaching from
 * its edge or committing anything.
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export const NAV_DRAWER_DISMISS = {
  thresholdPx: GESTURE_DEADZONE_PX,
  /** Travel toward the edge that commits the close on release. */
  commitThresholdPx: 72,
  /** Give on the closed-direction drag (the one that does nothing). */
  rubberBandFactor: 0.25,
  /** Hard cap on that give. */
  rubberBandLimitPx: 24,
  hapticMs: 12,
  /** Used for the backdrop fade when the panel has not been measured yet. */
  fallbackWidthPx: 280,
  /** A flick dismisses without reaching `commitThresholdPx`. */
  fling: { maxDurationMs: 300, minDistancePx: 40, axisRatio: 2 } satisfies FlingConfig,
} as const;
